/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportingMelcoMachineStatisticsModelsViewGroups,
    ReportingMelcoMachineStatisticsModelsViewGroupsFromJSON,
    ReportingMelcoMachineStatisticsModelsViewGroupsFromJSONTyped,
    ReportingMelcoMachineStatisticsModelsViewGroupsToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReportingMelcoMachineStatisticsModelsUpdateView
 */
export interface ReportingMelcoMachineStatisticsModelsUpdateView {
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoMachineStatisticsModelsUpdateView
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingMelcoMachineStatisticsModelsUpdateView
     */
    grouped_display?: boolean;
    /**
     * 
     * @type {Array<ReportingMelcoMachineStatisticsModelsViewGroups>}
     * @memberof ReportingMelcoMachineStatisticsModelsUpdateView
     */
    group_list?: Array<ReportingMelcoMachineStatisticsModelsViewGroups> | null;
}

export function ReportingMelcoMachineStatisticsModelsUpdateViewFromJSON(json: any): ReportingMelcoMachineStatisticsModelsUpdateView {
    return ReportingMelcoMachineStatisticsModelsUpdateViewFromJSONTyped(json, false);
}

export function ReportingMelcoMachineStatisticsModelsUpdateViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoMachineStatisticsModelsUpdateView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'grouped_display': !exists(json, 'grouped_display') ? undefined : json['grouped_display'],
        'group_list': !exists(json, 'group_list') ? undefined : (json['group_list'] === null ? null : (json['group_list'] as Array<any>).map(ReportingMelcoMachineStatisticsModelsViewGroupsFromJSON)),
    };
}

export function ReportingMelcoMachineStatisticsModelsUpdateViewToJSON(value?: ReportingMelcoMachineStatisticsModelsUpdateView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'grouped_display': value.grouped_display,
        'group_list': value.group_list === undefined ? undefined : (value.group_list === null ? null : (value.group_list as Array<any>).map(ReportingMelcoMachineStatisticsModelsViewGroupsToJSON)),
    };
}


